"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const base_1 = __importDefault(require("./base"));
const defaults_1 = require("./defaults");
class BadgeValue extends base_1.default {
    constructor(data = {
        id: undefined,
        level: undefined,
        value: undefined,
        next_value: undefined,
    }) {
        super(data);
        this.id = (0, defaults_1.defaultString)(data.id);
        this.level = (0, defaults_1.defaultNumber)(data.level);
        this.value = (0, defaults_1.defaultNumber)(data.value);
        this.next_value = (0, defaults_1.defaultNumber)(data.next_value);
    }
}
exports.default = BadgeValue;
